import { VacancyTopPictureProps } from "storyblok/components";
import Image from "next/legacy/image";

import { Wrapper } from "./VacancyTopPicture.styled";

import { optimizeImage } from "helpers/util/optimizeImage";

export function VacancyTopPicture({
    picture,
    reverse
}: VacancyTopPictureProps) {
    return (
        <Wrapper reverse={reverse}>
            <Image
                alt={picture.alt ?? "picture"}
                src={optimizeImage(picture.filename, picture.focus, true)}
                objectFit="cover"
                draggable={false}
                layout="fill"
            />
        </Wrapper>
    );
}
